import React from "react";
import "aos/dist/aos.css";

// Remplace ce chemin par l'image de ton choix dans ton dossier assets
import bigDataCloudImg from "../../assets/cloud.gif";

const BigDataCloud = () => {
  return (
    <section className="mt-16 w-full py-12 bg-[#F8FAFC]" id="big-data-cloud">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        {/* Image */}
        <div
          className="w-full md:w-1/2 flex justify-center"
          data-aos="fade-right"
        >

          <img
            src={bigDataCloudImg}
            alt="Illustration Analyse de Données"
            className="w-full max-w-xl md:max-w-2xl rounded-xl shadow-lg"
            loading="lazy"
          />
        </div>
        {/* Texte principal */}
        <div className="mt-4 w-full md:w-1/2" data-aos="fade-left">
          <h2 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
            Big Data et cloud computing
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            <span className="font-semibold text-[#00df9a]">Decintech</span> vous
            accompagne dans la gestion, le traitement et l’exploitation de
            volumes massifs de données grâce aux technologies Big Data et au
            Cloud Computing.
          </p>
          <ul className="space-y-2 text-base text-gray-800 mb-4">
            <li>
              <span className="font-semibold text-[#00df9a]">
                Stockage évolutif :
              </span>{" "}
              Solutions cloud pour stocker et sécuriser vos données sans limite
              de volume.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Traitement distribué :
              </span>{" "}
              Utilisation de frameworks comme Hadoop et Spark pour traiter
              d’importants ensembles de données en temps réel.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Ingestion de données :
              </span>{" "}
              Pipelines robustes pour intégrer des données issues de sources
              multiples (IoT, web, logs, bases SQL/NoSQL, etc.).
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Déploiement cloud :
              </span>{" "}
              Mise en œuvre d’architectures sur AWS, Azure ou Google Cloud pour
              garantir performance, sécurité et haute disponibilité.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Optimisation des coûts :
              </span>{" "}
              Solutions adaptées pour maîtriser vos dépenses tout en bénéficiant
              de la puissance du cloud.
            </li>
          </ul>
          <p className="text-gray-600">
            Nos experts conçoivent des infrastructures data modernes, évolutives
            et résilientes, pour transformer vos données en avantage
            concurrentiel.
          </p>
        </div>
      </div>
      {/* Section supplémentaire sous le bloc principal */}
      <div className="max-w-7xl mx-auto mt-12 px-4" data-aos="fade-up">
        <h3 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
          Technologies et expertises en  cloud data
        </h3>
        <ul className="list-disc pl-6 text-gray-800 space-y-2 mb-6">
          <li>
            <span className="font-semibold text-[#00df9a]">
              Hadoop, Spark :
            </span>{" "}
            Traitement distribué et analyse de données massives.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              AWS, Azure, Google Cloud :
            </span>{" "}
            Déploiement, stockage, sécurité et scalabilité.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Kafka, Airflow :
            </span>{" "}
            Orchestration et ingestion de flux de données en temps réel.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              NoSQL (MongoDB, Cassandra) :
            </span>{" "}
            Gestion de données non structurées à grande échelle.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Sécurité & Gouvernance :
            </span>{" "}
            Mise en place de politiques d’accès, chiffrement et conformité.
          </li>
        </ul>
        <p className="text-gray-700">
          Notre équipe vous accompagne dans la migration, l’optimisation et la
          valorisation de vos données dans le cloud, pour accélérer votre
          transformation digitale.
        </p>
      </div>
    </section>
  );
};

export default BigDataCloud;
